import { utils } from '@febos-io/common';
import { useCallback, useEffect, useRef, useState } from 'react';
// Create the main API client
export const mainApiClient = utils.createApiClient({
  baseURL: process.env['NX_API'] + '/' + process.env['NX_ENVIRONMENT'],
  useAuth: true,
  useLocalStorageHeaders: true,
  useAppHeader: true,
});

export default mainApiClient;
